import { Text } from 'components/Box'
import styled, { css } from 'styled-components'
import { rem } from 'polished'

export const captionStyles = css`
  font-size: ${({ size }) => (size === 'body' ? '1rem' : '0.8125rem')};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  overflow-wrap: ${props => props.overflowWrap || 'normal'};
  color: ${({ theme, color }) => color || theme.colors.text.dark.secondary};
`

const Caption = styled(Text).attrs({
  lineHeight: rem(20),
})`
  ${captionStyles}

  & p {
    margin-top: 0;
  }
`

export default Caption
